/* yr-expertise.js — upload to Online Store → Files → Assets */

(function () {
  'use strict';

  /* ---- STICKY TAB ACTIVE STATE ---- */
  const tabs = document.querySelectorAll('.yr-protokol-tabs__item');
  const sections = ['yr-section-ekspertiza', 'yr-section-proizvodi', 'yr-section-faq']
    .map(id => document.getElementById(id))
    .filter(Boolean);

  if (tabs.length && sections.length) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            tabs.forEach(tab => {
              tab.classList.toggle(
                'yr-protokol-tabs__item--active',
                tab.getAttribute('href') === '#' + id
              );
            });
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    sections.forEach(s => observer.observe(s));
  }

  /* ---- SMOOTH SCROLL FOR TAB LINKS ---- */
  tabs.forEach(tab => {
    tab.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          const tabsHeight = document.getElementById('yr-tabs')?.offsetHeight || 60;
          const top = target.getBoundingClientRect().top + window.scrollY - tabsHeight - 8;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    });
  });

  /* ---- AUTOPLAY GALLERY VIDEOS ---- */
  document.querySelectorAll('.yr-protocol-gallery__video').forEach(function (video) {
    video.muted = true;
    var playAttempt = video.play();
    if (playAttempt !== undefined) {
      playAttempt.catch(function () {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.play();
            }
          });
        });
        io.observe(video);
      });
    }
  });

  /* ---- FORMULA CARDS: tap-to-reveal на мобильных (hover не работает на touch) ---- */
  document.querySelectorAll('.yr-fcard--has-reveal').forEach(function (card) {
    card.addEventListener('click', function () {
      card.classList.toggle('is-revealed');
    });
  });

})();
